import { createSlice } from "@reduxjs/toolkit";
import { getReferralRewards } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IOperator } from "api/types/_operator";


export interface IState {
  rewards: ResponseData<IOperator[]> & PaginationResponse | null,
  isRewardLoading: boolean,
  isRewardSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  rewards: null,
  isRewardLoading: false,
  isRewardSuccess: false,

  error: {},
};

const RewardSlice = createSlice({
  name: "Reward",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get rewards
    builder.addCase(getReferralRewards.pending, (state: IState, action: any) => {
      state.isRewardLoading = true
    });
    builder.addCase(getReferralRewards.fulfilled, (state: IState, action: any) => {
      state.rewards = action.payload.data;
      state.isRewardSuccess = true;
      state.isRewardLoading = false;
    });
    builder.addCase(getReferralRewards.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isRewardSuccess = false;
      state.isRewardLoading = false;
    });
  },
});

export default RewardSlice.reducer;
